module.exports = __webpack_public_path__ + "static/media/fastclick.abcb7716.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/fastclick.png
// module id = 95
// module chunks = 0